module.exports = {
    "brand": "mc1dc15474_brand",
    "hiddenUncollapsed": "mc1dc15474_hiddenUncollapsed",
    "collapsed": "mc1dc15474_collapsed",
    "hiddenCollapsed": "mc1dc15474_hiddenCollapsed",
    "centerCollapsed": "mc1dc15474_centerCollapsed"
};